import { logError } from '../../utils/logger';

export const autoScrollViewHelper = error => {
    try {
        const errors = Object.keys(error) || [];
        if (errors.length > 1) {
            scrollToTop();
            return false;
        }
        const firstErrorField = errors[0]?.replace('error', '');
        const elAttribute = firstErrorField?.charAt(0)?.toLowerCase() + firstErrorField?.slice(1);
        const el = firstErrorField && querySelectByType('id', elAttribute);
        
        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                scrollMarginTop: '3rem'
            });
        }
    } catch (error) {
        logError(error, true, 'ccaAutoScrollViewHelper', {});
    }
};

const querySelectByType = (type, value) => document.querySelector(`[${type}="${value}"]`);
export const scrollToTop = () => {
    window.scrollTo(0, 0);
};
